import React from 'react';
import { useTranslation } from 'react-i18next';

export const Error403Box = () => {
  const { t } = useTranslation();
  return (
    <div className="ct-permission-error" data-e2e="ct-error-403-page">
      <h1>{t('permission_error')}</h1>
      <p>{t('error_403_message')}</p>
      <span>{t('access_restriction')}</span>
    </div>
  );
};
